import { useLocation } from "react-router-dom";
import { HeaderButtonsLoggedIn } from "@src/components/Header/HeaderButtonsLoggedIn";
import { HeaderButtonsNotLoggedIn } from "@src/components/Header/HeaderButtonsNotLoggedIn";
import { HeaderButtonsLoading } from "@src/components/Header/HeaderButtonsLoading";
import { VerifyEmailRibbon } from "@src/components/Header/Ribbons/VeryifyEmailRibbon";
import { BetaRibbon } from "@src/components/Header/Ribbons/BetaRibbon";

export const Header = (props) => {
  const routerLocation = useLocation();
  const chartType = routerLocation.pathname.split("/")[3];

  return (
    <>
      <BetaRibbon />
      {props.userIDReady &&
        props.loggedInUser &&
        props.loggedInUser !== "userNotFound" &&
        !props.loggedInUser?.emailVerified && (
          <>
            <VerifyEmailRibbon />
          </>
        )}
      <header className="_background-color--var_blue-30_">
        <div className="header_content_container">
          <h1>
            <a href="/" className="_color--white">
              Timeline
            </a>
          </h1>
          {(() => {
            switch (true) {
              case props.loggedInUser === "userNotFound":
                return (
                  <HeaderButtonsNotLoggedIn loggedInUser={props.loggedInUser} />
                );
              case !!props.loggedInUser:
                return (
                  <HeaderButtonsLoggedIn
                    loggedInUser={props.loggedInUser}
                    rowsIncludedState={props.rowsIncludedState}
                    chartType={chartType}
                    svgRef={props.svgRef}
                  />
                );
              case props.loggedInUser === undefined:
                return <HeaderButtonsLoading />;

              default:
                return null;
            }
          })()}
        </div>
      </header>
    </>
  );
};
